export const TextLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 397 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5768 39.2624H12.7684L16.7265 50.8874H8.65056L12.5768 39.2624ZM9.3209 35.0992L0 61.5517H5.07542L7.27796 55.0506H18.0672L20.2698 61.5517H25.3452L16.0562 35.1312H9.3209V35.0992Z"
      fill="#152CB9"
    />
    <path
      d="M44.5297 35.0992C49.7966 35.0992 53.3079 37.9174 53.3079 43.3296C53.3079 48.3254 49.7328 50.6312 45.8065 51.1116L53.4356 61.5196H47.3706L40.3161 51.2397H38.2412V61.5517H33.3893V35.1312H44.5297V35.0992ZM38.2412 46.9484H43.3805C46.6364 46.9484 48.4878 45.6994 48.4878 43.1694C48.4878 40.7676 47.1472 39.5186 43.8593 39.5186H38.2093V46.9484H38.2412Z"
      fill="#152CB9"
    />
    <path
      d="M82.2921 39.5506L79.9299 43.6818H79.7065C78.27 41.408 75.6844 39.0382 72.4285 39.0382C69.7791 39.0382 68.4065 40.4473 68.4065 42.1446C68.4065 44.1942 70.194 44.9628 74.4076 46.1157C79.3234 47.3967 83.5051 48.9339 83.5051 54.25C83.5051 59.3419 79.5469 62.032 73.9926 62.032C68.5342 62.032 64.6079 59.3419 62.8203 57.0041L65.0867 52.4566H65.3101C66.9062 54.6983 69.9387 57.4845 73.9607 57.4845C76.9613 57.4845 78.7488 56.4597 78.7488 54.3461C78.7488 51.7841 76.1313 51.1756 72.1093 50.1188C67.0339 48.7737 63.6183 46.9483 63.6183 42.1766C63.6183 38.0454 67.002 34.6508 72.3327 34.6508C77.472 34.6508 80.9195 37.469 82.2921 39.5506Z"
      fill="#152CB9"
    />
    <path
      d="M102.37 38.6539L104.477 60.5589L99.657 61.0393L97.5183 39.1023L90.2084 39.8068L89.7934 35.4194L109.329 33.53L109.744 37.9494L102.37 38.6539Z"
      fill="#152CB9"
    />
    <path
      d="M139.047 50.0868L134.802 44.7066L124.619 48.2934L124.715 55.1467L119.927 56.844L119.863 28.8223L126.215 26.5806L143.804 48.4215L139.047 50.0868ZM124.523 43.906L132.121 41.2159L124.523 31.5444L124.332 31.6085L124.523 43.906Z"
      fill="#152CB9"
    />
    <path
      d="M150.411 13.5465C155.104 11.1446 159.541 12.0733 161.998 16.8771C164.297 21.2965 162.158 24.9793 158.902 27.2211L170.458 33.0175L165.063 35.7717L154.082 29.8151L152.231 30.7758L156.955 39.9349L152.646 42.1446L140.516 18.6384L150.411 13.5465ZM150.252 26.9649L154.848 24.6271C157.753 23.1539 158.838 21.2004 157.657 18.9266C156.54 16.781 154.784 16.2686 151.88 17.7737L146.868 20.3357L150.252 26.9649Z"
      fill="#2F50EB"
    />
    <path
      d="M195.707 16.4287C196.76 22.1932 194.239 27.0609 187.376 28.2779C180.513 29.5269 176.299 25.876 175.246 20.1116L172.245 3.68285L177.001 2.81818L179.938 18.9907C180.576 22.5134 182.683 24.563 186.514 23.8585C190.312 23.1859 191.493 20.5279 190.855 17.0052L187.918 0.832645L192.706 0L195.707 16.4287Z"
      fill="#2F50EB"
    />
    <path
      d="M221.531 25.1395L220.541 29.4308L205.954 26.1643L211.763 0.384308L216.487 1.44113L211.636 22.9298L221.531 25.1395Z"
      fill="#2F50EB"
    />
    <path
      d="M251.473 21.2965L247.706 24.1787L247.483 24.0826C247.036 21.4566 245.599 18.2541 242.599 16.9731C240.173 15.9483 238.353 16.6849 237.683 18.2541C236.885 20.1436 238.226 21.5527 241.641 24.2428C245.663 27.3492 248.887 30.3915 246.812 35.2593C244.801 39.9669 240.141 40.8957 235.002 38.718C229.99 36.6043 227.404 32.6012 226.67 29.751L230.533 26.4525L230.756 26.5485C231.363 29.2066 233.054 32.9855 236.757 34.5227C239.502 35.6756 241.545 35.4514 242.375 33.4979C243.365 31.1281 241.194 29.5589 237.938 27.0289C233.789 23.7944 231.363 20.8161 233.246 16.4287C234.874 12.6498 239.311 10.8244 244.227 12.906C248.951 14.9235 251.026 18.8626 251.473 21.2965Z"
      fill="#2F50EB"
    />
    <path
      d="M277.041 55.8192L284.415 35.0351L284.351 35.0031L270.178 53.3853L265.678 51.7841L266.284 28.5981H266.22L258.815 49.3822L254.346 47.781L263.22 22.8977L270.753 25.5558L270.051 46.4039L270.146 46.436L282.787 29.8151L290.352 32.4731L281.478 57.3884L277.041 55.8192Z"
      fill="#2478FF"
    />
    <path
      d="M296.928 60.5268L299.641 34.2345L304.461 34.7469L301.748 61.0392L296.928 60.5268Z"
      fill="#2478FF"
    />
    <path
      d="M326.806 35.0992C332.073 35.0992 335.584 37.9174 335.584 43.3296C335.584 48.3254 332.009 50.6312 328.083 51.1116L335.712 61.5196H329.647L322.592 51.2076H320.518V61.5196H315.666V35.0992H326.806ZM320.518 46.9484H325.657C328.913 46.9484 330.764 45.6994 330.764 43.1694C330.764 40.7676 329.424 39.5186 326.136 39.5186H320.486V46.9484H320.518Z"
      fill="#2478FF"
    />
    <path
      d="M366.707 51.7841C366.707 57.6446 363.387 61.968 356.397 61.968C349.438 61.968 345.927 57.6126 345.927 51.7841V35.0992H350.779V51.5279C350.779 55.1147 352.502 57.4845 356.397 57.4845C360.259 57.4845 361.887 55.1147 361.887 51.5279V35.0992H366.707V51.7841Z"
      fill="#2478FF"
    />
    <path
      d="M395.787 39.5506L393.425 43.6818H393.201C391.765 41.408 389.179 39.0382 385.923 39.0382C383.274 39.0382 381.901 40.4473 381.901 42.1446C381.901 44.1942 383.689 44.9628 387.903 46.1157C392.818 47.3967 397 48.9339 397 54.25C397 59.3419 393.042 62.032 387.488 62.032C382.029 62.032 378.103 59.3419 376.315 57.0041L378.582 52.4566H378.805C380.401 54.6983 383.434 57.4845 387.456 57.4845C390.456 57.4845 392.244 56.4597 392.244 54.3461C392.244 51.7841 389.626 51.1756 385.604 50.1188C380.529 48.7737 377.113 46.9483 377.113 42.1766C377.113 38.0454 380.497 34.6508 385.828 34.6508C390.967 34.6508 394.414 37.469 395.787 39.5506Z"
      fill="#2478FF"
    />
  </svg>
);
